export default __webpack_public_path__ + "static/media/Roboto-Regular.5dd91892.ttf";